const moment = require("moment");

module.exports = function (timestamp) {
  return moment
    .unix(timestamp)
    .utcOffset(-window.Reqres.request("timezone").getOffsetMinutes())
    .format("MMM D, YYYY h:mm:ss A");
};
